


export const LeftSideBar= ({active,setActive, darkMode , setManualScroll})=>{
    return (
      <div className=" fixed left-0  z-10 top-0  flex-col h-screen  hidden md:flex  md:w-12 lg:w-20 justify-center  ">
        <button
          onClick={() => {
            setManualScroll(true);

            setActive("profile");
          }}
          className={`my-2 h-[2px] mx-2 sm:mx-4 md:mx-6 lg:mx-10 gap-3 hover:w-2 hover:sm:w-5 hover:md:w-7 hover:lg:w-8 ${
            active === "profile"
              ? `  w-3 sm:w-5 md:w-7 lg:w-10 h-[2px] ${
                  darkMode ? " bg-white" : "bg-black"
                }`
              : " w-2 sm:w-3 md:w-5 lg:w-6  bg-gray-500"
          }`}
        ></button>
        <button
          onClick={() => {
            setManualScroll(true);
            setActive("project");
          }}
          className={`my-2 h-[2px]  mx-2 sm:mx-4 md:mx-6 lg:mx-10 gap-3 hover:w-2 hover:sm:w-5 hover:md:w-7 hover:lg:w-8 ${
            active === "project"
              ? ` w-3 sm:w-5 md:w-7 lg:w-10 h-[2px] ${
                  darkMode ? " bg-white" : "bg-black"
                } `
              : " w-2 sm:w-3 md:w-5 lg:w-6 bg-gray-500"
          }`}
        ></button>
        <button
          onClick={() => {
            setManualScroll(true);
            setActive("contact");
          }}
          className={`my-2 h-[2px]  mx-2 sm:mx-4 md:mx-6 lg:mx-10 gap-3 hover:w-2 hover:sm:w-5 hover:md:w-7 hover:lg:w-8 ${
            active === "contact"
              ? ` w-3 sm:w-5 md:w-7 lg:w-10 h-[2px] ${
                  darkMode ? "bg-white" : "bg-black"
                }`
              : " w-2 sm:w-3 md:w-5 lg:w-6 bg-gray-500  hover:w-2 hover:sm:w-5 hover:md:w-7 hover:lg:w-8"
          }`}
        ></button>
        <div
          className={`fixed bottom-0 flex flex-col items-center  gap-16 ${
            active !== "profile"
              ? "translate-y-[300px]  duration-[3000ms]"
              : " duration-[3000ms]"
          }`}
        >
          <div className={`rotate-90 text-ms`}>SCROLL DOWN</div>
          <div
            className={`h-20  w-[2px]  ${darkMode ? " bg-white" : "bg-black"} `}
          ></div>
        </div>
      </div>
    );
}




  